(function () {
  if (window.snoozzzersCartUpsellBound) return;
  window.snoozzzersCartUpsellBound = true;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;

    event.preventDefault();
    if (button.hasAttribute('disabled')) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var label = button.querySelector('[data-cart-upsell-label]');
    var originalLabel = label ? label.textContent : '';
    var errorEl = document.querySelector('[data-cart-upsell-error]');
    var cartDrawer = document.querySelector('cart-drawer');

    if (errorEl) errorEl.hidden = true;
    button.setAttribute('disabled', 'disabled');
    if (label) label.textContent = button.getAttribute('data-adding-text') || 'Adding';

    var payload = {
      items: [{ id: Number(variantId), quantity: 1 }]
    };

    if (cartDrawer) {
      payload.sections = 'cart-drawer,cart-icon-bubble';
      payload.sections_url = window.location.pathname;
    }

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
          cartDrawer.renderContents(data);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        button.removeAttribute('disabled');
        if (label) label.textContent = originalLabel;
        if (errorEl) errorEl.hidden = false;
      });
  });
})();
